import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { useLocation, Link } from 'react-router-dom'
import { getRouteLabelMap } from '@/config/menuItems'

const PageBreadcrumb = () => {
  const location = useLocation()
  const pathSnippets = location.pathname.split('/').filter((i) => i)
  const routeLabelMap = getRouteLabelMap()

  const breadcrumbItems = [
    {
      title: (
        <Link to="/">
          <HomeOutlined />
        </Link>
      ),
    },
  ]

  // 构建面包屑路径
  // 非末级路径（大菜单）不可点击：它们没有独立页面，只是子菜单的容器
  let currentPath = ''
  pathSnippets.forEach((snippet) => {
    currentPath += `/${snippet}`
    const label = routeLabelMap[currentPath] || snippet

    breadcrumbItems.push({
      title: <span>{label}</span>,
    })
  })

  return <Breadcrumb items={breadcrumbItems} />
}

export default PageBreadcrumb
